import React from "react";
import { Tooltip, Popconfirm, Checkbox } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  setAddJobsModal,
  setJobLoading,
  setJobsViewMOdal,
} from "../../actions/JobActions";
import { AllJobs } from "../Jobs/service";
import { extractDate } from "../Tickets/service";

export const Columns = (dispatch) => {
  return [
    {
      title: "Id",
      key: "1",
      width: 150,
      render: (_, object) => object?.id,
    },
    {
      key: "2",
      title: "Title",
      width: 150,
      render: (_, object) => object?.title,
    },

    {
      key: "4",
      title: "Experience",
      width: 150,
      render: (_, object) => object?.experience,
    },
    {
      key: "5",
      title: "Type",
      width: 150,
      render: (_, object) => object?.job_type,
    },
    {
      key: "6",
      title: "status",
      width: 150,
      render: (_, object) => (
        <Checkbox checked={object?.status === "inactive" ? false : true} />
      ),
    },
    {
      key: "8",
      title: "Created At",
      width: 150,
      render: (_, object) => extractDate(object?.created_at),
    },
    {
      key: "9",
      title: "Updated At",
      width: 150,
      render: (_, object) => extractDate(object?.updated_at),
    },
  ];
};
